import React, { forwardRef } from "react";
import { Link as RouterLink, type LinkProps as RouterLinkProps } from "react-router-dom";

type Href = string | { pathname?: string; query?: Record<string, string | number | boolean> };

export type LinkProps = Omit<RouterLinkProps, "to"> & {
  href: Href;
};

function toLocation(href: Href): RouterLinkProps["to"] {
  if (typeof href === "string") return href;
  const pathname = href.pathname || "/";
  const search = href.query
    ? `?${new URLSearchParams(Object.entries(href.query).map(([key, value]) => [key, String(value)])).toString()}`
    : "";
  return `${pathname}${search}`;
}

const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link({ href, ...props }, ref) {
  return <RouterLink ref={ref} to={toLocation(href)} {...props} />;
});

export default Link;
